import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SatisfactionService {

  constructor(private http: HttpClient) {}

  requestSatisfaction(satisfaction: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/satisfaction`,
      satisfaction
    );
  }
  requestHasReplied(idclient: any, idbien: any, email: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/satisfaction/hasReplied`,
      {idclient, idbien, email}
    );
  }
}
